// Порядок ключей — шкала лиг снизу вверх: на нем держатся таблицы по лигам,
// раздел правил «Боты» и тесты монотонности. Новая лига — только в конец
export const LEAGUES = {
  BRONZE: 'bronze',
  SILVER: 'silver',
  GOLD: 'gold',
  DIAMOND: 'diamond',
  RUBY: 'ruby',
  GOD: 'god',
}
